<navigation></navigation>
<header></header>
<router-outlet></router-outlet>
<footer></footer>
